export const REVISAO_TITLE = "Revisão";
export const AVISO_REVISAO =
  "Confira de onde sai e para onde vai o Tipo de Obra, os escopos macro que vão junto e o impacto no Outlook das duas Obras.";
export const CARREGANDO_REVISAO_LABEL = "Carregando revisão...";
export const SAI_DE = "Sai de";
export const VAI_PARA = "Vai para";
export const OBRA_LABEL = "Obra";
export const EMBARCACAO_LABEL = "Embarcação";
export const TIPO_OBRA_LABEL = "Tipo de Obra";
export const CENTRO_CUSTO_LABEL = "Centro de custo";
export const INCORPORACAO = (codigo: string, nome: string) =>
  `Os escopos entram no Tipo de Obra ${codigo} - ${nome} que a Obra de destino já tem neste centro de custo.`;
export const TIPO_CRIADO_NO_DESTINO = "O Tipo de Obra será criado na Obra de destino.";

export const ESCOPOS_TITLE = "Escopos macro que vão junto";
export const ESCOPOS_LABEL = "Escopos macro da transferência";
export const COLUNA_ESCOPO = "Escopo macro";
export const COLUNA_SITUACAO = "Situação";
export const COLUNA_PERIODO = "Período no destino";
export const COLUNA_CLASSIFICACAO = "Classificação";
export const COLUNA_PARAMETROS = "Parâmetros";
export const COLUNA_TOTAL = "Total (R$ MM)";
export const COLUNA_ACAO = "Ação";
export const TOTAL_LABEL = "Total";
export const REVISAR_LABEL = "Revisar";
export const REVISAR_ROTULO_CARTAO = "Escopo macro em revisão";
export const REVISAR_ARIA = (escopo: string) => `Revisar ${escopo}`;
export const SITUACAO_IMPEDIDO = "Impedido";
export const SITUACAO_PENDENCIA_TEMPORAL = "Pendência temporal";
export const SITUACAO_APTO = "Apto";
export const PREVIA_TIPO_ERRO = "Não foi possível calcular a projeção dos escopos no destino.";
export const PREVIA_TIPO_PERMISSAO =
  "Você não tem permissão para consultar a projeção dos escopos.";
export const REVISAR_SEM_PROJECAO = "Este escopo não tem projeção vigente para revisar.";
export const REVISAR_ERRO = "Não foi possível carregar os parâmetros do escopo na origem.";
export const CARREGANDO_PREVIA_LABEL = "Calculando a projeção no destino...";
export const PENDENCIA_DURACAO = (fim: string) =>
  `A duração passa do término da Obra de destino: o escopo fica com pendência de duração (${fim}). A transferência pode seguir.`;
export const IMPEDIDO_AVISO =
  "Há escopo impedido: a transferência não pode ser solicitada enquanto houver impedimento.";

export const FINANCEIRO_TITLE = "Financeiro e Outlook";
export const OUTLOOK_ORIGEM = "Outlook da Obra de origem (R$ MM)";
export const OUTLOOK_DESTINO = "Outlook da Obra de destino (R$ MM)";
export const VALOR_TIPO_ORIGEM = "Valor do Tipo na origem";
export const VALOR_TIPO_DESTINO = "Valor do Tipo no destino";

export const DOMINANCIA_ORIGEM_TITLE = "Dominância na Obra de origem";
export const DOMINANCIA_DESTINO_TITLE = "Dominância na Obra de destino";
export const SUCESSOR_JUSTIFICATIVA_LABEL = "Justificativa da escolha do dominante";
export const TROCA_JUSTIFICATIVA_LABEL = "Justificativa da troca do dominante";
export const JUSTIFICATIVA_SUCESSOR_OBRIGATORIA =
  "Informe a justificativa da escolha do dominante.";
export const JUSTIFICATIVA_TROCA_OBRIGATORIA = "Informe a justificativa da troca do dominante.";
export const SUCESSOR_OBRIGATORIO = "Selecione o novo Tipo de Obra dominante.";
